export const LEMBRETE_USUARIO_CADASTRADO_TODAS_EMPRESAS_SELECIONADAS = 'Lembrete: O usuário será cadastrado em todas as empresas selecionadas.'

const User = {
  LEMBRETE_USUARIO_CADASTRADO_TODAS_EMPRESAS_SELECIONADAS,
}

export default User
